module.exports = __webpack_public_path__ + "img/hall4.af4f07e7.png";